import React, { useState } from 'react';
import { Modal } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { getMedia } from '../utilities/Utils';

const ImageGallery = ({ config, receiptFiles, setReceiptFiles, receiptBase64s, setReceiptBase64s, attachmentArr }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedMediaToken, setSelectedMediaToken] = useState(null);

    const handleImageClick = (base64) => {
        setSelectedImage(base64);
    };

    const handleMediaTokenClick = (media_token) => {
        setSelectedMediaToken(media_token);
    };

    const handleRemoveImage = (index) => {
        let updatedBase64s = [...receiptBase64s];
        let updatedFiles = [...receiptFiles];
        const [removedPreview] = updatedBase64s.splice(index, 1);
        updatedFiles.splice(index, 1);
        if (removedPreview?.startsWith('blob:')) {
            URL.revokeObjectURL(removedPreview);
        }
        setReceiptFiles(updatedFiles);
        setReceiptBase64s(updatedBase64s);
        setSelectedImage(null);
    };

    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 12 }}>
                {attachmentArr?.map((el, index) => {
                    return (
                        <div key={index} style={{ position: 'relative' }}>
                            <img
                                key={index}
                                src={getMedia(el.media_token)}
                                style={{
                                    width: '80px',
                                    height: '80px',
                                    marginRight: 8,
                                    cursor: 'pointer'
                                }}
                                onClick={() => handleMediaTokenClick(el.media_token)}
                            />
                        </div>
                    );
                })}
                {receiptBase64s?.map((el, index) => (
                    <div key={index} style={{ position: 'relative' }}>
                        <img
                            key={index}
                            src={el}
                            style={{
                                width: '80px',
                                height: '80px',
                                marginRight: 8,
                                cursor: 'pointer'
                            }}
                            onClick={() => handleImageClick(el)}
                        />
                        <div onClick={() => handleRemoveImage(index)} style={{ cursor: 'pointer' }}>
                            <Cancel style={{ position: 'absolute', top: 3, right: 10, color: config.theme.color }} />
                        </div>
                    </div>
                ))}
            </div>
            {selectedImage && (
                <Modal open={true} onClose={() => setSelectedImage(null)}>
                    <div
                        className="customModal"
                        style={{
                            width: 'calc(100vw - 100px)',
                            height: 'calc(100vh - 200px)',
                            padding: 0
                        }}
                    >
                        <img src={selectedImage} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                    </div>
                </Modal>
            )}
            {selectedMediaToken && (
                <Modal open={true} onClose={() => setSelectedMediaToken(null)}>
                    <div
                        className="customModal"
                        style={{
                            width: 'calc(100vw - 100px)',
                            height: 'calc(100vh - 200px)',
                            padding: 0
                        }}
                    >
                        <img src={getMedia(selectedMediaToken)} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default ImageGallery;
